/**
 * iterable 한 오브젝트를 plain 한 object 로 변환합니다(디버깅용도)
 */
export function convertIterableToMap(
  anyIterable: any
): Record<any, any> | undefined {
  if (!anyIterable) {
    return;
  }
  const map: Record<string, any> = {};

  if (anyIterable.forEach) {
    anyIterable.forEach((value: any, key: any) => {
      map[key] = value;
    });
  } else {
    for (const [key, value] of Object.entries(anyIterable)) {
      map[key] = value;
    }
  }

  return map;
}
